import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import 'moment/locale/ru';
import { GET, JSXMap, POST, deleteInArray, errorCatch, updateInArray, useAuth, useUserContext } from 'fennec-ui'
import 'moment/locale/ru';
import { Switch } from 'antd-mobile';

var _ = require('lodash');

export default function Subscriptions(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();

    const [rassilki, setRassilki] = useState()
    const [podpiski, setPodpiski] = useState()

    useEffect(() => {
        GET(auth, `/api/rassilki/list?s-id&w-unsubscribeForbidden=false`,
            ({ data }) => {
                setRassilki(data)
            }, errorCatch)
        GET(auth, `/api/podpiski/list`,
            ({ data }) => {
                setPodpiski(data)
            }, errorCatch)

    }, [])

    const [loading, setLoading] = useState(false);

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "stretch", fontSize: "14px" }}>
            {JSXMap(rassilki, (e, idx) => {
                const podpiska = podpiski?.find(p => p.rassilkaID == e.ID);
                return (
                    <div key={idx} style={{ padding: "10px 10px", width: "100%", borderTop: "1px solid #eee", display: "flex", gap: "7px" }}>
                        <div style={{ flex: "1 1 auto" }}>
                            <div style={{ fontWeight: "600" }}>
                                {e.nazvanie}
                            </div>
                            <div>
                                {e.opisanie}
                            </div>
                            {podpiska && <div style={{ paddingTop: "5px" }}>
                                <div key={idx} style={{ padding: "2px 0px", display: "flex", gap: "10px" }}>
                                    <div style={{ flex: "0 0 80px", alignSelf: "center" }}>
                                        <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                            Max
                                        </div>
                                    </div>
                                    <div style={{ flex: "0 0" }}>
                                        <Switch
                                            loading={loading}
                                            style={{
                                                "--height": "20px",
                                                "--width": "40px"
                                            }}
                                            checked={(podpiska?.max) ? true : false}
                                            onChange={(checked) => {
                                                setLoading(true)
                                                POST(auth, `/api/podpiski/update`, { ...podpiska, max: checked },
                                                    ({ data }) => {
                                                        if (data) {
                                                            setPodpiski(updateInArray(podpiski, data));
                                                            setLoading(false)
                                                        } else {
                                                            setPodpiski(deleteInArray(podpiski, podpiska))
                                                            setLoading(false)
                                                        }
                                                    }, (err) => errorCatch(err, () => setLoading(false))
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <div key={idx} style={{ padding: "2px 0px", display: "flex", gap: "10px" }}>
                                    <div style={{ flex: "0 0 80px", alignSelf: "center" }}>
                                        <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                            Telegram
                                        </div>
                                    </div>
                                    <div style={{ flex: "0 0" }}>
                                        <Switch
                                            loading={loading}
                                            style={{
                                                "--height": "20px",
                                                "--width": "40px"
                                            }}
                                            checked={(podpiska?.tg) ? true : false}
                                            onChange={(checked) => {
                                                setLoading(true)
                                                POST(auth, `/api/podpiski/update`, { ...podpiska, tg: checked },
                                                    ({ data }) => {
                                                        if (data) {
                                                            setPodpiski(updateInArray(podpiski, data));
                                                            setLoading(false)
                                                        } else {
                                                            setPodpiski(deleteInArray(podpiski, podpiska))
                                                            setLoading(false)
                                                        }
                                                    }, (err) => errorCatch(err, () => setLoading(false))
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <div key={idx} style={{ padding: "2px 0px", display: "flex", gap: "10px" }}>
                                    <div style={{ flex: "0 0 80px", alignSelf: "center" }}>
                                        <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                            Vk
                                        </div>
                                    </div>
                                    <div style={{ flex: "0 0" }}>
                                        <Switch
                                            loading={loading}
                                            style={{
                                                "--height": "20px",
                                                "--width": "40px"
                                            }}
                                            checked={(podpiska?.vk) ? true : false}
                                            onChange={(checked) => {
                                                setLoading(true)
                                                POST(auth, `/api/podpiski/update`, { ...podpiska, vk: checked },
                                                    ({ data }) => {
                                                        if (data) {
                                                            setPodpiski(updateInArray(podpiski, data));
                                                            setLoading(false)
                                                        } else {
                                                            setPodpiski(deleteInArray(podpiski, podpiska))
                                                            setLoading(false)
                                                        }
                                                    }, (err) => errorCatch(err, () => setLoading(false))
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <div key={idx} style={{ padding: "2px 0px", display: "flex", gap: "10px" }}>
                                    <div style={{ flex: "0 0 80px", alignSelf: "center" }}>
                                        <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                            Email
                                        </div>
                                    </div>
                                    <div style={{ flex: "0 0" }}>
                                        <Switch
                                            loading={loading}
                                            style={{
                                                "--height": "20px",
                                                "--width": "40px"
                                            }}
                                            checked={(podpiska?.email) ? true : false}
                                            onChange={(checked) => {
                                                setLoading(true)
                                                POST(auth, `/api/podpiski/update`, { ...podpiska, email: checked },
                                                    ({ data }) => {
                                                        if (data) {
                                                            setPodpiski(updateInArray(podpiski, data));
                                                            setLoading(false)
                                                        } else {
                                                            setPodpiski(deleteInArray(podpiski, podpiska))
                                                            setLoading(false)
                                                        }
                                                    }, (err) => errorCatch(err, () => setLoading(false))
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>}
                        </div>
                        <div style={{ flex: "0 0" }}>
                            <Switch
                            loading={loading}
                                checked={(podpiska) ? true : false}
                                onChange={(checked) => {
                                    if (!checked) {
                                        setLoading(true)
                                        GET(auth, `/api/podpiski/delete/${podpiska.ID}`,
                                            () => {
                                                setPodpiski(deleteInArray(podpiski, podpiska))
                                                setLoading(false)
                                            }, (err) => errorCatch(err, () => setLoading(false))
                                        );
                                    } else {
                                        setLoading(true)
                                        POST(auth, `/api/podpiski/new`, { rassilkaID: e.ID },
                                            ({ data }) => {
                                                setPodpiski(updateInArray(podpiski, data));
                                                setLoading(false)
                                            }, (err) => errorCatch(err, () => setLoading(false))
                                        )
                                    }
                                }}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    );
}


{/* <List header='复杂列表'>
        <List.Item extra={<Switch defaultChecked />}>新消息通知</List.Item>
        <List.Item extra='未开启' clickable>
          大字号模式
        </List.Item>
        <List.Item description='管理已授权的产品和设备' clickable>
          授权管理
        </List.Item>
        <List.Item title='副标题信息A' description='副标题信息B' clickable>
          这里是主信息
        </List.Item>
      </List> */}